module.exports = __webpack_public_path__ + "static/media/upload.8a7a280b.svg";